import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../comum/Context/auth.jsx";
import { api } from "../../services/api.js";
import Menu from "../../comum/Menu/index.jsx";
import Footer from "../../comum/Footer/index.jsx";
import Card from "../Components/CardHome/index.jsx";
import "./index.css";
import BirthdayCarousel from "../Components/CardAniversario/index.jsx";
import gorroNatal from './../../../public/Images/gorro.png';

import { Modal, Button } from "react-bootstrap";
import { format, differenceInYears, differenceInMonths, differenceInDays, addYears, addMonths } from "date-fns";
import { ptBR } from "date-fns/locale";

// Importa as imagens de sentimento
import img1 from './../../../public/Images/1.png';
import img2 from './../../../public/Images/2.png';
import img3 from './../../../public/Images/3.png';
import img4 from './../../../public/Images/4.png';
import img5 from './../../../public/Images/5.png';

const sentimentos = [
    { id: 1, label: "", png: img1 },
    { id: 2, label: "", png: img2 },
    { id: 3, label: "", png: img3 },
    { id: 4, label: "", png: img4 },
    { id: 5, label: "", png: img5 },
];

const DEFAULT_USER = "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg";
const cacheKey = (chapa) => `foto_${String(chapa)}`;
const getCachedPhoto = (chapa) => localStorage.getItem(cacheKey(chapa));
const setCachedPhoto = (chapa, dataUrl) => { try { localStorage.setItem(cacheKey(chapa), dataUrl); } catch { } };


function Home() {
    const { logado } = useContext(AuthContext);
    const [usuarioInfo, setUsuarioInfo] = useState(null);
    const [fotoPerfilUrl, setFotoPerfilUrl] = useState(null);
    const [sentimentoImg, setSentimentoImg] = useState(null);
    const [admissaoFormatada, setAdmissaoFormatada] = useState("");
    const [tempoEmpresa, setTempoEmpresa] = useState("");
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const [qtdemsg, setQtdemsg] = useState(0);
    const permiteCheckList = localStorage.getItem("CHECKLIST");
    const permiteCadastroCheckTI = localStorage.getItem("TICADCHECKLIST");
    const isCheckCadastro = permiteCadastroCheckTI === "S";
    const itsChecklist = permiteCheckList === "S";
    const [temaAtivo, setTemaAtivo] = useState("off");
    const [mensagemTema, setMensagemTema] = useState(""); // Novo state para a mensagem


    useEffect(() => { if (!logado) window.location.href = "/"; }, [logado]);

    // --- LÓGICA DE DETECÇÃO E EXECUÇÃO DOS TEMAS (NEVE / FOGOS) ---
    useEffect(() => {
        const hoje = new Date();
        const dia = hoje.getDate();
        const mes = hoje.getMonth() + 1;

        function detectarTema(dataAtual = { mes, dia }) {
            const params = new URLSearchParams(window.location.search);
            const forcado = params.get("tema");

            if (forcado === "natal") return "natal";
            if (forcado === "anonovo") return "anonovo";
            if (forcado === "off") return "off";

            if ((dataAtual.mes === 11 && dataAtual.dia >= 20) || (dataAtual.mes === 12 && dataAtual.dia >= 1 && dataAtual.dia <= 24)) return "natal";
            if ((dataAtual.mes === 12 && dataAtual.dia >= 25) || (dataAtual.mes === 1 && dataAtual.dia <= 2)) return "anonovo";

            return "off";
        }

        const tema = detectarTema();
        setTemaAtivo(tema);

        // Define a mensagem do tema
        if (tema === "natal") {
            setMensagemTema("Um Feliz Natal!");
        } else if (tema === "anonovo") {
            setMensagemTema("Feliz Ano Novo!");
        } else {
            setMensagemTema("");
        }

        // Se não for Ano Novo, o cleanup cuidará de remover qualquer canvas antigo
        if (tema !== "anonovo") return;

        // --- CRIAÇÃO E INICIALIZAÇÃO DOS FOGOS DE ARTIFÍCIO ---

        let animationFrameId;
        let intervalo;

        const canvas = document.createElement('canvas');
        canvas.id = "fogosCanvas";

        canvas.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            pointer-events: none;
            z-index: 99999; 
            display: block;
        `;

        document.body.appendChild(canvas);

        const ctx = canvas.getContext("2d");

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        };

        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        const particles = [];
        const random = (min, max) => Math.random() * (max - min) + min;

        function criarExplosao() {
            const x = random(100, canvas.width - 100);
            const y = random(50, canvas.height / 2);

            const cores = [
                "rgba(255, 71, 71, 0.8)", "rgba(255, 190, 71, 0.8)", "rgba(255, 255, 71, 0.8)",
                "rgba(99,255,71, 0.8)", "rgba(71,255,250, 0.8)", "rgba(71,123,255, 0.8)",
                "rgba(193,71,255, 0.8)", "rgba(255,71,199, 0.8)"
            ];
            const cor = cores[Math.floor(Math.random() * cores.length)];

            for (let i = 0; i < 50; i++) {
                particles.push({
                    x, y,
                    angle: random(0, Math.PI * 2),
                    speed: random(2, 6),
                    size: random(2, 4),
                    alpha: 1,
                    color: cor,
                    gravity: 0.04,
                    friction: 0.96,
                    decay: random(0.01, 0.02),
                });
            }
        }

        function animar() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.globalCompositeOperation = "lighter";

            for (let i = particles.length - 1; i >= 0; i--) {
                const p = particles[i];
                p.speed *= p.friction;
                p.x += Math.cos(p.angle) * p.speed;
                p.y += Math.sin(p.angle) * p.speed + p.gravity;
                p.alpha -= p.decay;

                ctx.beginPath();
                ctx.fillStyle = p.color.replace("0.8", p.alpha.toFixed(2));
                ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
                ctx.fill();

                if (p.alpha <= 0 || p.y > canvas.height) {
                    particles.splice(i, 1);
                }
            }
            animationFrameId = requestAnimationFrame(animar);
        }

        intervalo = setInterval(criarExplosao, 900);
        animar();

        return () => {
            if (intervalo) clearInterval(intervalo);
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
            window.removeEventListener('resize', resizeCanvas);

            if (canvas && canvas.parentNode) {
                canvas.parentNode.removeChild(canvas);
            }
        };

    }, []);

    // --- LÓGICA DE DADOS DO USUÁRIO ---
    useEffect(() => {
        // ... (restante da lógica de dados do usuário)
        const info = localStorage.getItem("usuarioInfo");
        const sentimento = localStorage.getItem("sentido");
        const chapa = localStorage.getItem("chapa");
        const storedQtdemsg = localStorage.getItem("msg");


        // 1. Atualiza o state de qtdemsg com o valor do localStorage (inicialmente)
        const msgCount = storedQtdemsg ? parseInt(storedQtdemsg, 10) : 0;
        setQtdemsg(msgCount);

        // 2. FUNÇÃO ASYNC PARA CHAMAR A API E ATUALIZAR A CONTAGEM
        const fetchUnreadMessages = async (userChapa) => {
            if (!userChapa) return;
            try {
                // Chamada da API para buscar mensagens com status 'E' (Não lidas)
                const res = await api.get(`/usuario/notificacoes?usuario=${chapa}&status=E`);
                const newMsgCount = res.data.total; // Assume que o retorno é um array
                // Atualiza o localStorage e o state
                localStorage.setItem("msg", String(newMsgCount));
                setQtdemsg(newMsgCount);

            } catch (error) {
                console.error("Erro ao buscar notificações não lidas:", error);
            }
        };

        if (info) {
            const parsed = JSON.parse(info);
            setUsuarioInfo(parsed);

            // **CHAMADA PRINCIPAL: Busca a quantidade de mensagens não lidas**
            fetchUnreadMessages(chapa);

            console.log("Sentimento: " + sentimento);
            if (sentimento) {
                const s = sentimentos.find((x) => x.id.toString() === sentimento);
                if (s) setSentimentoImg(s.png);
            }

            const cachedPerfil = getCachedPhoto(chapa) || DEFAULT_USER;
            setFotoPerfilUrl(cachedPerfil);

            (async () => {
                const res = await api.get(`/usuario/foto/${chapa}`).catch(() => null);
                const admissaoIso = res?.data?.dataadmissao || null;
                if (res?.data?.foto) {
                    const freshUrl = `data:image/jpeg;base64,${res.data.foto}`;
                    if (freshUrl !== cachedPerfil) {
                        setCachedPhoto(chapa, freshUrl);
                        setFotoPerfilUrl(freshUrl);
                    }
                }
                if (admissaoIso) {
                    const adm = new Date(admissaoIso.split('T')[0] + 'T00:00:00');
                    setAdmissaoFormatada(format(adm, "dd/MM/yyyy", { locale: ptBR }));
                    const hoje = new Date();
                    const anos = differenceInYears(hoje, adm);
                    const meses = differenceInMonths(hoje, addYears(adm, anos)) % 12;
                    const base = addMonths(addYears(adm, anos), meses);
                    const dias = differenceInDays(hoje, base);
                    setTempoEmpresa(`${anos} ano(s), ${meses} mes(es) e ${dias} dia(s)`);
                }
            })();
        }
    }, []);

    const chapa = localStorage.getItem("chapa");
    const isRestrito = chapa?.startsWith("90");
    const AcessoSap = localStorage.getItem("SAPADM") === "S";
    const permiteVendas = localStorage.getItem("permiteVendas") === "S";
    const permitePonto = localStorage.getItem("permitePonto") === "S";
    const itsAcessoRegional = chapa === '900010' || chapa === '900001';
    const permiteRegional = localStorage.getItem("permiteRegional") === "S";
    const hasPhoto = (url) => !!url && url !== DEFAULT_USER;
    const permiteDashBoardRH = localStorage.getItem("RHDASHBOARD") === "S";


    const openFoto = (fotoUrl, nome, chapaX) => {
        if (!hasPhoto(fotoUrl)) return;
        setFotoSelecionada({ foto: fotoUrl, nome, chapa: chapaX });
    };

    const goToNotificacoes = () => {
        window.location.href = "/arbor/notificacoes/";
    };


    if (!usuarioInfo) return <div>Carregando...</div>;

    const linksRH = [
        { to: "/arbor/aeflor", text: "AEFLOR - Eventos", icon: "fa-user-plus" },
        ...((!isRestrito) ? [

            { to: "/arbor/chamado", text: "Atendimento RH", icon: "fa-question-circle" },
            { to: "/arbor/atestado", text: "Atestados", icon: "fa-user-md" },
            { to: "/arbor/aeflor/convenio", text: "Convênio", icon: "fa-credit-card" },
            { to: "/arbor/dadosFunc/", text: "Meus Dados", icon: "fa-address-card" },
            { to: "/arbor/escala/", text: "Escala de trabalho", icon: "fa-calendar" },
            { to: "/arbor/holerite/", text: "Holerites", icon: "fa-envelope-o" },
            { to: "/arbor/notificacoes/", text: "Notificações", icon: "fa-bell" },
            { to: "/arbor/ponto/", text: "Ponto", icon: "fa-clock-o" }
        ] : []),
        { to: "/arbor/restaurante/", text: "Refeição", icon: "fa-check-square-o" }
    ];

    return (
        <div>
            <Menu modulo="ARBOR" />

            {/* ❄️ Efeito de neve (visível apenas no tema "natal") */}
            {temaAtivo === "natal" && (
                <>
                    {[...Array(30)].map((_, i) => (
                        <div
                            key={i}
                            className="snowflake"
                            style={{
                                left: `${Math.random() * 100}vw`,
                                animationDuration: `${6 + Math.random() * 6}s`,
                                animationDelay: `${Math.random() * 5}s`
                            }}
                        >
                            ❄️
                        </div>
                    ))}
                </>
            )}

            {/* NOVO: Div para a mensagem temática */}
            {mensagemTema && (
                <div className={`mensagem-tema ${temaAtivo}`}>
                    {mensagemTema}
                </div>
            )}

            <div className="container-fluid mt-12 home-container">
                {/* INÍCIO: Balão Flutuante de Notificação */}
                {qtdemsg > 0 && (
                    <div
                        onClick={goToNotificacoes}
                        style={{
                            position: 'fixed',
                            top: '100px',
                            right: '20px',
                            zIndex: 1000,
                            cursor: 'pointer',
                            backgroundColor: '#dc3545',
                            color: 'white',
                            borderRadius: '50%',
                            width: '45px',
                            height: '45px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                            fontSize: '1.2rem',
                            border: '3px solid #ffc107',
                        }}
                        title={`${qtdemsg} Mensagem(ns) não lida(s)`}
                    >
                        <i className="fa fa-bell" />
                        <span
                            style={{
                                position: 'absolute',
                                top: '-5px',
                                right: '-5px',
                                fontSize: '0.7rem',
                                padding: '2px 5px',
                                borderRadius: '50%',
                                backgroundColor: '#ffc107',
                                color: '#dc3545',
                                fontWeight: 'bold'
                            }}
                        >
                            {qtdemsg}
                        </span>
                    </div>
                )}
                {/* FIM: Balão Flutuante de Notificação */}

                <h5 />
                <div className="user-profile mb-12 text-center">
                    <div className="foto-container">

                        <img
                            src={fotoPerfilUrl || DEFAULT_USER}
                            alt="Foto do Usuário"
                            className="user-photo rounded-circle"
                            onClick={() =>
                                hasPhoto(fotoPerfilUrl) && openFoto(fotoPerfilUrl, usuarioInfo.NOME, chapa)
                            }
                            style={{ cursor: hasPhoto(fotoPerfilUrl) ? "zoom-in" : "default" }}
                        />

                        {sentimentoImg && (
                            <img
                                src={sentimentoImg}
                                alt="Sentimento"
                                className="sentimento-flutuante"
                            />
                        )}
                    </div>

                    <h6 className="text-muted mt-3">
                        {usuarioInfo?.nomefilial || usuarioInfo?.NOMEFILIAL || ""}
                    </h6>
                    <h2 className="mt-2">Bem-vindo, {usuarioInfo.NOME}!</h2>
                    <p className="text-muted">
                        {chapa} | {usuarioInfo.FUNCAO || ""}
                        <br />
                        {admissaoFormatada || ""}
                        <br />
                        {tempoEmpresa}
                    </p>
                </div>

                {/* Aniversariantes */}
                <h6 className="mt-2 text-center">
                    Aniversariantes de {new Date().toLocaleString("pt-BR", { month: "long" })}
                </h6>
                <BirthdayCarousel />

                {/* Cards */}
                <div className="row mx-auto justify-content-center h-100 mt-3">
                    {(!isRestrito || itsAcessoRegional) && (
                        <div className="col-12 col-md-6 col-lg-4 mb-3">
                            <Card
                                title="Recursos Humanos"
                                icon="fa-users"
                                links={linksRH}
                            />
                        </div>
                    )}

                    {(permiteDashBoardRH || AcessoSap || permiteVendas || permitePonto || chapa === "900010" || chapa === "900001") && (
                        <div className="col-12 col-md-6 col-lg-4 mb-3">
                            <Card
                                title="Ferramentas"
                                icon="fa-wrench"
                                links={[
                                    { to: "/arbor/produto/", text: "Etiqueta", icon: "fa-barcode" },
                                    permiteVendas && { to: "/arbor/usuario/consinco/", text: "Associar Operador PDV", icon: "fa-users" },
                                    permiteVendas && { to: "/arbor/produto/auditoria/", text: "Auditoria Produto", icon: "fa fa-cubes" },
                                    isCheckCadastro && { to: "/arbor/rh/acidente/", text: "Comunicado de Ocorrência", icon: "fa-user-md" },
                                    permiteRegional && { to: "/arbor/comunicado/", text: "Comunicação DRH", icon: "fa-address-book" },
                                    permiteVendas && { to: "/arbor/vendas/flash/", text: "Vendas - Flash", icon: "fa-bolt" },
                                    itsChecklist && { to: "/arbor/checklist/checklist/", text: "CheckList TI", icon: "fa-check-square-o" },
                                    ...(permiteDashBoardRH ? [
                                        { to: "/arbor/rh/dashboard", text: "Dashboard RH", icon: "fa-deaf" }
                                    ] : []),
                                    permitePonto && { to: "/arbor/ponto/ocorrencias/", text: "Ocorrências de Ponto", icon: "fa-clock-o" },
                                    AcessoSap && { to: "/arbor/sap/", text: "SAP", icon: "fa-money" },
                                    permiteVendas && { to: "/arbor/vendas/flash/", text: "Vendas - Flash", icon: "fa-bolt" },
                                    permiteVendas && { to: "/arbor/vendas/mes/", text: "Vendas - Período", icon: "fa-line-chart" },
                                    permiteVendas && { to: "/arbor/vendas/loja/", text: "Vendas - Período Loja", icon: "fa-line-chart" },
                                    permiteVendas && { to: "/arbor/vendas/comparativo/", text: "Vendas - Comparativo", icon: "fa-line-chart" },

                                    { to: "/arbor/validade/", text: "Validade", icon: "fa-calendar" }
                                ].filter(Boolean)}
                            />
                        </div>
                    )}
                    {(!isRestrito || chapa === "900010" || chapa === "900001") && (
                        <div className="col-12 col-md-6 col-lg-4 mb-3">
                            <div className="">
                                <Card
                                    title="Ouvidoria"
                                    icon="fa-deaf"
                                    links={[{ to: "/arbor/ouvidoria/", text: "Abrir Protocolo", icon: "fa-deaf" }]}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Footer />
            <Modal show={!!fotoSelecionada} onHide={() => setFotoSelecionada(null)} centered>
                <Modal.Body className="text-center p-4">
                    {fotoSelecionada && (
                        <>
                            <img src={fotoSelecionada.foto} alt="Foto" className="modal-photo" />
                            <div className="mt-3" style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                                {fotoSelecionada.nome} ({fotoSelecionada.chapa})
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setFotoSelecionada(null)}>Fechar</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Home;